import React, { useEffect } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { RouteProp } from '@react-navigation/native';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';
import EmailListConfiguration from '../../../../shared/EmailListConfiguration';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import useProfileVisitInviteEmails from '../../../../../hooks/api/useProfileVisitInviteEmails';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

const intl = getIntl('VisitInviteEmailsScreen', {
    subscribe: 'Subscribe',
    unsubscribeAll: 'Unsubscribe All',
});

export type VisitInviteEmailsScreenOwnProps = {};

export type VisitInviteEmailsScreenProps = VisitInviteEmailsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'visit-invite-emails'>;
};

const VisitInviteEmailsScreen: React.FC<VisitInviteEmailsScreenProps> = (props) => {
    const goBack = useGoBack();
    const { isLoadingEmails, emails, isUpdatingEmails, updateEmails } = useProfileVisitInviteEmails({
        medicalProfileId: props.route.params.profileId,
        onUpdateEmails: goBack,
    });
    const [workingEmails, setWorkingEmails] = React.useState<string[]>([]);
    useEffect(() => {
        setWorkingEmails(emails.map((_) => _.inviteeEmail));
    }, [emails]);

    return (
        <AnimateLoadedContent isLoading={isLoadingEmails || isUpdatingEmails}>
            {() => (
                <ActionButtonLayout
                    actions={[
                        {
                            title: workingEmails.length ? intl('subscribe') : intl('unsubscribeAll'),
                            onPress: () => {
                                updateEmails({
                                    emails: workingEmails,
                                });
                            },
                            isDisabled: isUpdatingEmails,
                            testID: 'submit-subscription-button',
                            icon: workingEmails.length ? 'Check' : 'XCircle',
                        },
                    ]}
                >
                    <MainContentContainer>
                        <EmailListConfiguration
                            value={workingEmails}
                            onChange={setWorkingEmails}
                            medicalProfileId={props.route.params.profileId}
                        />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(VisitInviteEmailsScreen);
